<template>
  <pt-detection-update class="pt-detection-update__page"></pt-detection-update>
</template>

<script>
import PtDetectionUpdate from 'cps/gene-product/pt-detection-update/withData'
export default {
  name: 'pt-detection-update__view',
  components: {
    'pt-detection-update': PtDetectionUpdate
  }
}
</script>
